"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setOrganizationDetails = exports.closeUserSession = exports.setupUserSession = void 0;
var organizations_1 = require("@fuze/apis-foundry/dist/organizations");
var users_1 = require("@fuze/apis-foundry/dist/users");
var user_session_1 = require("./user-session");
var query_string_1 = require("query-string");
var users_2 = require("@fuze/apis-foundry/dist/users");
// TODO There is no reason to store the whole hub customer object
function setupUserSession(_a) {
    var entity = _a.entity, permissions = _a.permissions;
    return __awaiter(this, void 0, void 0, function () {
        var isImpersonationUser, foundryUser, _b, hubCustomer, queryParams;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    isImpersonationUser = entity.origin.id.includes("impersonation");
                    if (!isImpersonationUser) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, users_2.getUserWithOriginalImpersonatorToken)(entity.origin.idpId)];
                case 1:
                    _b = _c.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, (0, users_1.getUser)(entity.userId)];
                case 3:
                    _b = _c.sent();
                    _c.label = 4;
                case 4:
                    foundryUser = _b;
                    entity.permissions = permissions;
                    (0, user_session_1.setUser)(__assign(__assign({}, entity), foundryUser));
                    (0, user_session_1.setOrganization)(entity.tenantKey); // default to the user's customer
                    hubCustomer = JSON.parse(localStorage.getItem("hubCustomer"));
                    if (!hubCustomer) return [3 /*break*/, 6];
                    return [4 /*yield*/, setOrganizationDetails(hubCustomer.code)];
                case 5:
                    _c.sent();
                    return [3 /*break*/, 8];
                case 6: return [4 /*yield*/, setOrganizationDetails(entity.tenantKey)];
                case 7:
                    _c.sent();
                    _c.label = 8;
                case 8:
                    queryParams = (0, query_string_1.parse)(window.location.search.replace("?", ""));
                    if (!(queryParams && !!queryParams.organization)) return [3 /*break*/, 10];
                    if (!(queryParams.organization !== (0, user_session_1.getOrganization)())) return [3 /*break*/, 10];
                    return [4 /*yield*/, setOrganizationDetails(queryParams.organization)];
                case 9:
                    _c.sent();
                    _c.label = 10;
                case 10: return [2 /*return*/];
            }
        });
    });
}
exports.setupUserSession = setupUserSession;
function closeUserSession() {
    (0, user_session_1.setUser)(undefined);
    (0, user_session_1.setOrganization)(undefined);
    localStorage.removeItem("hubCustomer");
}
exports.closeUserSession = closeUserSession;
function setOrganizationDetails(organizationCode) {
    return __awaiter(this, void 0, void 0, function () {
        var organizationData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, organizations_1.getOrganization)(organizationCode)];
                case 1:
                    organizationData = _a.sent();
                    if (!!organizationData) {
                        (0, user_session_1.setOrganization)(organizationData.code);
                        localStorage.setItem("hubCustomer", JSON.stringify(organizationData));
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.setOrganizationDetails = setOrganizationDetails;
